import React from 'react';
import { Breadcrumb, BreadcrumbItem, Card, CardHeader, CardBody, CardTitle, CardText, CardImg } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';
import { FadeTransform } from 'react-animation-components';

function RenderManagementImage({ item, isLoading, errMess }) {

    if (isLoading) {
        return (
            <Loading />
        );
    }
    else if (errMess) {
        return (
            <h4>{errMess}</h4>
        );
    }
    else
        return (
            <FadeTransform in
                transformProps={{
                    exitTransform: 'scale(0.5) translateY(-50%)'
                }}>
                <Card>
                    <CardImg width="100%" src={item.image} alt={item.name} />
                    {item.imageTwo ? <CardImg width="100%" src={item.imageTwo} alt={item.nameTwo} /> : null}
                    {item.description ?
                        <CardBody>
                            {item.categoryOne ? <CardTitle>{item.categoryOne}</CardTitle> : null}
                            <CardText>{item.description}</CardText>
                            {item.categoryTwo ? <CardTitle>{item.categoryTwo}</CardTitle> : null}
                            {item.descriptionTwo ? <CardText>{item.descriptionTwo}</CardText> : null}
                        </CardBody> : null}
                </Card>
            </FadeTransform >
        );
}

function Management(props) {

    return (
        <div className="container">
            <div className="row">
                <Breadcrumb>
                    <BreadcrumbItem><Link to="/finance">Finance</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Financial Management</BreadcrumbItem>
                </Breadcrumb>
                <div className="col-12">
                    <h3>Financial Management</h3>
                    <hr />
                </div>
            </div>
            <div className="row row-content">
                <div className="col-12 col-md-6">
                    <RenderManagementImage item={props.management} isLoading={props.financesLoading}
                        errMess={props.financesErrMess} />
                    <Card>
                        <CardHeader className="bg-primary text-white">Financial Goals - In the Spotlight</CardHeader>
                        <CardBody>
                            <dl className="row p-1">
                                <dt className="col-12">1. Have an emergency fund.</dt>
                                <ul>
                                    <li><b>Planned cost = $12k</b></li>
                                </ul>
                                <dt className="col-12">2. Buy a home by July 2027.</dt>
                                <ul>
                                    <li><b>Planned cost = $112k</b></li>
                                    <li><b>How much home can you comfortably afford?</b></li>
                                    <dd className="col-12">Think about how much money you have available to make your down payment.</dd>
                                    <li><b>Weigh the options of buying an expensive small home/APT in the city vs a larger home in the suburbs for a cheaper cost.</b></li>
                                    <dd className="col-12">In the city, you and your wife can get by with just one car that is used only for trips out of the city. If you moved 20 km's out of the city, there's the cost of an additional car to get to work; more wear and tear on both cars, AND at that distance, take commuter hour traffic into consideration.</dd>
                                    <li><b>Figure out how much you can reasonably pay each month for your mortgage, property taxes and homeowners insurance.</b></li>
                                    <dd className="col-12">This number will normally be the size of the check you will have to write each month as your mortgage payment, and it will give you an idea of how large a loan you may be able to support. Keep in mind that many lenders expect your monthly payment to be less than some specific percentage limit, often 28% to 36% of your gross monthly income.</dd>
                                    <li><b>Plan for extra costs when buying a home, such as: home maintenance and daily budgeting expenses.</b></li>
                                </ul>
                                <dt className="col-12">3. Have a travel budget for honeymoon.</dt>
                                <ul>
                                    <li><b>After allocating for home fund, any surplus from salary goes to travel budget.</b></li>
                                    <li><b>Planned cost = $20k</b></li>
                                </ul>
                                <dt className="col-12">4. Pay off your home early.</dt><ul></ul>
                                <dt className="col-12">5. Build wealth and give.</dt>
                            </dl>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-12 col-md-6">
                    <RenderManagementImage item={props.baby} isLoading={props.financesLoading}
                        errMess={props.financesErrMess} />
                </div>
            </div>
            <div className="row row-content">
                <div className="col-12 col-md-5">
                    <Card>
                        <CardHeader className="bg-primary text-white">Buying a Home (Important Notes)</CardHeader>
                        <CardBody>
                            <dl className="row p-1">
                                <dt className="col-12">1. Don't buy a home unless you are:</dt>
                                <ul>
                                    <li><dd className="col-12">Out of debt</dd></li>
                                    <li><dd className="col-12">Have an emergency fund</dd></li>
                                </ul>
                                <dt className="col-12">2. When buying a home:</dt>
                                <ul>
                                    <li><dd className="col-12">ALWAYS, 100% down payment is ideal</dd></li>
                                    <ul><li><dd className="col-12">Else, FOLLOW these <u>rules</u> for obtaining a loan:</dd></li></ul>
                                    <li><dd className="col-12">The payment should be no more than 35% of your take home pay</dd></li>
                                    <li><dd className="col-12">In addition, get a real estate pro/broker (this is not a DIY Project)—because a 1% mistake is tens of thousands of dollars</dd></li>
                                </ul>
                                <dt className="col-12">3. Never borrow currency, and if you do:</dt>
                                <ul>
                                    <li><dd className="col-12">it should ONLY be for buying a home, and make sure to pay it off ASAP</dd></li>
                                </ul>
                                <dt className="col-12">Note:</dt>
                                <li><dd className="col-12">INCOME IS YOUR MOST POWERFUL WEALTH BUILDING TOOL--YOU NEED CASH FLOW, OR ELSE, YOU'RE INVITING STRESS</dd></li>
                            </dl>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-12 col-md-6">
                    <h2>Are you ready to buy a home?</h2>
                    <p>There's a lot to consider about homeownership. Are you a renter with a desire to purchase your first home? An existing homeowner considering buying a vacation home? A retiree thinking about relocating and downsizing? Whether it's a starter home, your retirement home or something in between, the decision is a big one.</p>
                    <p><b>Here are <em>five questions</em> that you should consider before buying a home:</b></p>
                    <h5>1. Is owning the roof over your head your No. 1 priority?</h5>
                    <h5>2. Do you expect any big changes in your life in the next few years?</h5>
                    <p>Could your career make it necessary for you to move? Are you thinking about starting a family? Is it possible that you might need to take care of ailing parents soon? If you've got major short-term plans or expenses, you might think twice about buying now. In most cases, you should stay in a home for at least five years to recoup your upfront costs.</p>
                    <div className="col-12">
                        <Card>
                            <CardBody className="bg-faded">
                                <blockquote className="blockquote">
                                    <p className="mb-0">Buying a home should mesh with the rest of your priorities. Having other financial goals doesn't necessarily prevent you from buying a home, but it could help narrow your price range or lead you to consider postponing the purchase for a few years.</p>
                                    <footer className="blockquote-footer">Neil Stikeleather,
                                        <cite title="Source Title">Merrill Lynch Wealth Management Advisor</cite>
                                    </footer>
                                </blockquote>
                            </CardBody>
                        </Card>
                    </div>
                    <h5>3. Have you saved enough for your down payment?</h5>
                    <p>The traditional practice is to put down at least 20% of the purchase price of a home in cash. It's important that you're comfortable with the monthly mortgage payment, which will include the principal on the loan, plus interest, as well as the amount put aside monthly to cover real estate taxes and insurance. It's also important to have sufficient emergency savings set aside so that you could comfortably make the mortgage payments for several months in the event your income was suddenly reduced. If you're nearing retirement (or already retired), you're likely thinking about living on your retirement income. Consider how a mortgage payment would factor into your budget.</p>
                    <div className="col-12">
                        <Card>
                            <CardBody className="bg-faded">
                                <blockquote className="blockquote">
                                    <p className="mb-0">It's important that you're comfortable with the monthly mortgage payment, which will include the principal on the loan, plus interest, as well as the amount put aside monthly to cover real estate taxes and insurance.</p>
                                    <footer className="blockquote-footer">Neil Stikeleather,
                                        <cite title="Source Title">Merrill Lynch Wealth Management Advisor</cite>
                                    </footer>
                                </blockquote>
                            </CardBody>
                        </Card>
                    </div>
                    <h5>4. Are you aware of all the expenses of being a homeowner?</h5>
                    <p>Costs like heating and insurance are often higher for homeowners. You may also have to pay for things you currently get for free, such as waste removal and lawn care. And when the hot water heater breaks or a storm damages your roof in the middle of the night, you won't be able to simply call your landlord. Aside from standard homeowner expenses, inquire if there is homeowner taxes.</p>
                    <h5>5. Might it make sense for you to rent?</h5>
                    <p>Don't feel pressured by the conventional wisdom that now is a good time to buy before prices and interest rates climb higher. That way of thinking makes more sense for someone who is investing in real estate. You don't want to get caught up in the noise around real estate when you're making a decision about your family and your future.</p>
                    <p>Look at your take-home pay and living costs — and how those numbers will change when you move into a home. The point here isn't to discourage anyone. But homeownership is a big life decision, and you need to be fully aware of the commitment it requires before you sign on the dotted line.</p>
                </div>
            </div>
            <div className="row row-content">
                <div className="col-12 col-md-6">
                    <h2>Investments</h2>
                    <RenderManagementImage item={props.investment} isLoading={props.financesLoading}
                        errMess={props.financesErrMess} />
                    <Card>
                        <CardHeader className="bg-primary text-white">Retirement</CardHeader>
                        <CardBody>
                            <dl className="row p-1">
                                <dt className="col-12">1. Always use an investment professional that has the heart of a teacher.</dt>
                                <ul>
                                    <li><dd className="col-12">Make sure the person who manages your fund has the heart of a teacher (so you understand what your goose does and when it will lay it’s golden eggs).</dd></li>
                                </ul>
                                <dt className="col-12">2. Do not invest in things you do not understand.</dt>
                                <ul>
                                    <li><dd className="col-12">Till you understand, do NOT put a dime in it.</dd></li>
                                </ul>
                                <dt className="col-12">3. Don’t be afraid to pay commission when using a financial management broker.</dt>
                            </dl>
                        </CardBody>
                    </Card>
                    {/* <p></p>
                    <h5>Research on how Australians retire?</h5>
                    <div className="col-12">
                        <Card>
                            <CardBody className="bg-faded">
                                <blockquote className="blockquote">
                                    <p className="mb-0">Slow and steady investing of $500-1500 per month will make you a millionaire by the time you retire.</p>
                                    <p className="mb-0">Better yet, 15% of your household income.</p>
                                    <footer className="blockquote-footer">Aaron John,
                                        <cite title="Source Title"> 02/09/2022</cite>
                                    </footer>
                                </blockquote>
                            </CardBody>
                        </Card>
                    </div> */}
                </div>
                <div className="col-12 col-md-6">
                    <p></p>
                    <Card>
                        <CardHeader className="bg-primary text-white">Stock Market</CardHeader>
                        <CardBody>
                            <dl className="row p-1">
                                <dt className="col-12">Invest in good growth stock mutual funds—spread it across 4 types:</dt><ul></ul>
                                <dt className="col-12">1. Growth and income fund</dt>
                                <ul>
                                    <li><dd className="col-12">Also called large cap fund or blue chip fund. It is the most stable investment (it moves really slow and has an upward trend)</dd></li>
                                </ul>
                                <dt className="col-12">2. Growth</dt>
                                <ul>
                                    <li><dd className="col-12">Mid cap fund (return is between large and small cap—not too slow and not too aggressive)</dd></li>
                                </ul>
                                <dt className="col-12">3. Aggressive Growth</dt>
                                <ul>
                                    <li><dd className="col-12">Also called small cap fund</dd></li>
                                </ul>
                                <dt className="col-12">4. Global/International fund (preferably a European company)</dt>
                                <ul></ul>
                                <dt className="col-12">Notes:</dt>
                                <ul>
                                    <li><dd className="col-12">Buy mutual funds that have at least a 10 year track record</dd></li>
                                    <li><dd className="col-12">The s&p 500 fund mirrors the market (it basically is the stock market)</dd></li>
                                    <li><dd className="col-12">The mutual funds that you buy should outperform the s&p 500</dd></li>
                                    <li><dd className="col-12">When contrasting, if the chosen mutual fund investment MA is <u><b>above</b></u> the s&p 500 MA then <u>it is a good investment</u> (meaning it will outperform the s&p 500/stock market)</dd></li>
                                </ul>
                            </dl>
                        </CardBody>
                    </Card>
                </div>
            </div>
            <div className="row row-content">
                <div className="col-12">
                    <h2>Distribution and Expenditure</h2>
                    <Card>
                        <CardHeader className="bg-primary text-white">Have 6 Bank Accounts (for Distribution and Expenditure):</CardHeader>
                        <CardBody>
                            <dl className="row p-1">
                                <dt className="col-12">1. First bank account: "Emergency Fund - SAVINGS" (at Commonwealth Bank)</dt>
                                <ul>
                                    <li><dd className="col-12">This account is for Emergency Fund</dd></li>
                                    <li><dd className="col-12">12,000 AUD will (always) be stacked in here—this is not an investment—it’s an insurance policy—ONLY FOR “EMERGENCY”</dd></li>
                                    <li><dd className="col-12">This account will be linked to Commonwealth Bank Transaction account—for emergency withdrawal</dd></li>
                                </ul>
                                <dt className="col-12">2. Second bank account: "Weekly Budget - TRANSACTION" (at Commonwealth Bank)</dt>
                                <ul>
                                    <li><dd className="col-12">This account is for income deposits and weekly budget</dd></li>
                                    <li><dd className="col-12">Pay monthly rent and deposit remaining monthly budget to ING Transaction account</dd></li>
                                </ul>
                                <dt className="col-12">3. Third bank account: "Monthly Budget - TRANSACTION" (at ING Orange Everyday)</dt>
                                <ul>
                                    <li><dd className="col-12">This account is for monthly budget</dd></li>
                                    <li><dd className="col-12">From received monthly budget deposit, move surplus dollars--at the end of the month--to ING Savings account</dd></li>
                                    <li><dd className="col-12">If you have more income coming in, move it to ING Savings account</dd></li>
                                </ul>
                                <dt className="col-12">4. Fourth bank account: "Home Fund - SAVINGS" (ING Savings Maximiser)</dt>
                                <ul>
                                    <li><dd className="col-12">This account is a savings fund for Home, Wedding, and PR (Goal is 150k and upwards)</dd></li>
                                    <ul><li><dd className="col-12">Once Wedding and PR is crossed off, this account will become a Travel savings fund</dd></li></ul>
                                </ul>
                                <dt className="col-12">5. Fifth and Sixth bank account: "Family Care - TRANSACTION and SAVINGS" (ING Orange Everyday and Savings Maximiser)</dt>
                                <ul>
                                    <li><dd className="col-12">The everyday account will be personal to each member</dd></li>
                                    <ul><li><dd className="col-12">Will be used for fun money and partner care</dd></li></ul>
                                    <li><dd className="col-12">The savings account will be personal to each member</dd></li>
                                    <ul><li><dd className="col-12">Any surplus not used from everyday account will be moved to savings account</dd></li></ul>
                                </ul>
                            </dl>
                        </CardBody>
                    </Card>
                </div>
            </div>
            <div className="row row-content">
                <div className="col-12 col-md-6">
                    <h2>Other Financial Notes</h2>
                    <Card>
                        <CardHeader className="bg-primary text-white">Financial Lessons</CardHeader>
                        <CardBody>
                            <dl className="row p-1">
                                <dt className="col-12">1. Always, ALways, ALWays, ALWAys, ALWAYs, ALWAYS:</dt>
                                <ul>
                                    <li><dd className="col-12">Obtain a receipt (or signed document) when making a business transaction</dd></li>
                                </ul>
                                <dt className="col-12">2. Debt:</dt>
                                <ul>
                                    <li><dd className="col-12">Don’t lease depreciating assets like cars, boats, RV's, motorcycles. If you can't afford to pay cash then you can't afford it. Mandatory payments keep you from financial independence. Choose. Independence or toys?</dd></li>
                                </ul>
                                <dt className="col-12">3. Make life a sport</dt>
                                <ul>
                                    <li><dd className="col-12">Measure how you're doing. Keep score. Celebrate your successes. Learn from your mistakes. Compete to make yourself the best version of you.</dd></li>
                                </ul>
                            </dl>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-12 col-md-6">
                    <RenderManagementImage item={props.other} isLoading={props.financesLoading}
                        errMess={props.financesErrMess} />
                </div>
            </div>
        </div >
    );
}

export default Management;    


// WEBPACK FOOTER //
// ./src/components/ManagementComponent.js